var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16663 2.33329C4.94496 2.33329 2.33329 4.94496 2.33329 8.16663C2.33329 11.3883 4.94496 14 8.16663 14C11.3883 14 14 11.3883 14 8.16663C14 4.94496 11.3883 2.33329 8.16663 2.33329ZM0.666626 8.16663C0.666626 4.02449 4.02449 0.666626 8.16663 0.666626C12.3088 0.666626 15.6666 4.02449 15.6666 8.16663C15.6666 12.3088 12.3088 15.6666 8.16663 15.6666C4.02449 15.6666 0.666626 12.3088 0.666626 8.16663Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2857 12.2857C12.6111 11.9603 13.1388 11.9603 13.4642 12.2857L17.0892 15.9107C17.4147 16.2361 17.4147 16.7638 17.0892 17.0892C16.7638 17.4147 16.2361 17.4147 15.9107 17.0892L12.2857 13.4642C11.9603 13.1388 11.9603 12.6111 12.2857 12.2857Z",
    fill: "#637381"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f570e740a0a5bd564a065e66c70d6c9f.svg";
export { ForwardRef as ReactComponent };